/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	var windowW = $(window).width();
	var windowH = $(window).innerHeight();
	var hSize;
	
	var _isSP;
	
	var prewidth = window.innerWidth; //preload
	
	(0, _module.preload)(); //toggleHeader
	
	(0, _module.toggleHeader)(); //showMovie
	
	(0, _module.showMovie)(); //showImg
	
	(0, _module.showImg)(); //divideCharacter
	
	(0, _module.divideCharacter)(); //anchorLink
	// import {anchorLink} from "../include/module";
	// anchorLink();
	// $(window).on('resize load' , function() {
	//   if(windowW <= 1024){
	//     _isSP = true;
	//   } else {
	//     _isSP = false;
	//   };
	//   //リサイズ処理 ブレイクポイントを跨いだらリロード
	//   var nowWidth = window.innerWidth;
	//   if(prewidth !== nowWidth){
	//     if(prewidth < 1025) {
	//       if(nowWidth >= 1025){
	//         location.reload();
	//       }
	//     }else {
	//       if(nowWidth < 1025){
	//         location.reload();
	//       }
	//     }
	//   };
	// });
	
	$(window).on('load', function () {
	  $(".st-Container").addClass('is-show');
	  scrollDetailAnime();
	  toggleImg();
	}); // ------------------------------------------------------------------------
	// toggleImg
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var changeBtn = document.getElementById('change-Btn');
	var _isChange = false;
	
	var toggleImg = function toggleImg() {
	  if (changeBtn != null) {
	    changeBtn.addEventListener('click', function () {
	      if (!_isChange) {
	        setTimeout(function () {
	          $(".panel-item-on").removeClass('is-show');
	          $(".panel-item-off").addClass('is-show');
	          $("#change-Btn").removeClass('on');
	          _isChange = true;
	        }, 0);
	      } else {
	        setTimeout(function () {
	          $(".panel-item-on").addClass('is-show');
	          $(".panel-item-off").removeClass('is-show');
	          $("#change-Btn").addClass('on');
	          _isChange = false;
	        }, 0);
	      }
	    }, false);
	  }
	}; // ------------------------------------------------------------------------
	// scrollDetailAnime
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	var scrollDetailAnime = function scrollDetailAnime() {
	  function getDuration() {
	    return $('.index-Keyvisual_Container').height();
	  }
	
	  var controller = new ScrollMagic.Controller(); //ttl
	
	  var scene = new ScrollMagic.Scene({
	    triggerElement: '.index-Keyvisual_Container',
	    // duration: 500,
	    triggerHook: 1,
	    duration: getDuration,
	    offset: '0'
	  }).setClassToggle(".index-Keyvisual_Container", "sticky") // .addIndicators({name: "1"})
	  .addTo(controller); //　スクロールで発火
	
	  var targets = document.querySelectorAll(".js-scrollAnimation");
	  var targetsArray = Array.prototype.slice.call(targets); //Array
	
	  targetsArray.forEach(function (target) {
	    //シーンを作成
	    new ScrollMagic.Scene({
	      triggerElement: target,
	      triggerHook: .9
	    }).setClassToggle(target, "is-animated").addTo(controller);
	  });
	};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mouseStalker = exports.divideCharacter = exports.showImg = exports.showMovie = exports.toggleHeader = exports.anchorLink = exports.pageTop = exports.preload = void 0;
	var headerFlag = false;
	var stHeader = document.getElementById('st-Header');
	var stHeaderNav = document.getElementById('st-Header_Nav');
	var stHeaderBg = document.getElementById('st-Header_Bg');
	var headerButton = document.getElementById('st-Menu');
	var $modal = $('#sw-Youtube');
	var $content = $('#sw-Youtube_Content'); // var windowW       = $(window).width();
	// var windowH       = $(window).innerHeight();
	// var _isSP         = false;
	// var _isipad  = false;
	// ------------------------------------------------------------------------
	// preload
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var preload = function preload() {
	  history.replaceState(null, null, null);
	  window.addEventListener('popstate', function () {
	    $('body').addClass('preload'); // headerFlag        = false;
	    // stHeaderNav.classList.remove('opened');
	    // headerButton.classList.remove('opened');
	    // stHeaderBg.classList.remove('opened');
	    // stHeaderLogo.classList.remove('opened');
	    // stHeaderNav.classList.add('closed');
	    // headerButton.classList.add('closed');
	    // stHeaderBg.classList.add('closed');
	    // stHeaderLogo.classList.add('closed');
	
	    setTimeout(function () {
	      $('body').removeClass('preload');
	    }, 100);
	  }, false);
	  $(window).on('load', function () {
	    $("body").removeClass("preload");
	  });
	}; // ------------------------------------------------------------------------
	// toggleHeader
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.preload = preload;
	
	var toggleHeader = function toggleHeader() {
	  headerButton.addEventListener('click', function () {
	    if (!headerFlag) {
	      // $('#st-Header_Navi').css({'display':'block'});
	      setTimeout(function () {
	        stHeader.classList.remove('closed');
	        stHeaderNav.classList.remove('closed');
	        headerButton.classList.remove('closed');
	        stHeaderBg.classList.remove('closed');
	        stHeader.classList.add('opened');
	        stHeaderNav.classList.add('opened');
	        headerButton.classList.add('opened');
	        stHeaderBg.classList.add('opened');
	        headerFlag = true;
	      }, 0);
	    } else {
	      stHeader.classList.remove('opened');
	      stHeaderNav.classList.remove('opened');
	      headerButton.classList.remove('opened');
	      stHeaderBg.classList.remove('opened');
	      stHeader.classList.add('closed');
	      stHeaderNav.classList.add('closed');
	      headerButton.classList.add('closed');
	      stHeaderBg.classList.add('closed');
	      headerFlag = false; // setTimeout(function(){
	      //   // $('#st-Header_Navi').css({'display':'none'});
	      // },0);
	    }
	  }, false);
	}; // ------------------------------------------------------------------------
	// pageTop
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.toggleHeader = toggleHeader;
	
	var pageTop = function pageTop() {
	  $("#st-Top").on("click", function () {
	    var linkSpeed = 800;
	    $("html, body").animate({
	      scrollTop: 0
	    }, linkSpeed, "easeOutExpo");
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.pageTop = pageTop;
	
	var anchorLink = function anchorLink() {
	  //ページ外からのページ内リンク
	  var urlHash = location.hash;
	
	  if (urlHash) {
	    $('body,html').stop().scrollTop(0);
	    setTimeout(function () {
	      var target = $(urlHash);
	      var position = target.offset().top - 80;
	      $('body,html').stop().animate({
	        scrollTop: position
	      }, 500);
	    }, 200);
	  }
	
	  var linkSpeed = 1000;
	  var linkAdjust = 20; //ページ内リンク
	
	  $("a[href^='#']").on("click", function () {
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({
	      scrollTop: linkPosition - linkAdjust
	    }, linkSpeed, "easeInOutQuint");
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// showMovie
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.anchorLink = anchorLink;
	
	var showMovie = function showMovie() {
	  // open
	  $('.js-Youtube').on('click', function () {
	    var dataID = $(this).attr('data-youtube');
	    $('#sw-Youtube').css({
	      'opacity': '0',
	      'display': 'block'
	    }).stop().animate({
	      'opacity': '1',
	      'width': 100 + '%',
	      'height': 100 + 'vh',
	      'top': 0,
	      'left': 0
	    }, 500, 'easeOutQuart', function () {
	      //iframe append
	      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/' + dataID + '?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>'); // fadeIn
	
	      $modal.stop().fadeIn(400);
	      return false;
	    });
	  }); //close
	
	  $('#sw-Youtube_Close,#sw-Youtube_Content ').on('click', function () {
	    $('#sw-Youtube').css({
	      'opacity': '1'
	    }).stop().animate({
	      'opacity': '0'
	    }, 500, 'easeOutQuart', function () {
	      $('#sw-Youtube').css({
	        'display': 'none'
	      });
	      $content.children().remove();
	    });
	  });
	}; // ------------------------------------------------------------------------
	// showImg
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.showMovie = showMovie;
	
	var showImg = function showImg() {
	  // open
	  $('.js-Img').on('click', function () {
	    var dataID = $(this).attr('data-img');
	    $('#sw-Youtube').css({
	      'opacity': '0',
	      'display': 'block'
	    }).stop().animate({
	      'opacity': '1',
	      'width': 100 + '%',
	      'height': 100 + 'vh',
	      'top': 0,
	      'left': 0
	    }, 500, 'easeOutQuart', function () {
	      //img append
	      $content.append('<img src="' + dataID + '">'); // fadeIn
	
	      $modal.stop().fadeIn(400);
	      return false;
	    });
	  }); //close
	}; // ------------------------------------------------------------------------
	// divideCharacter
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.showImg = showImg;
	
	var divideCharacter = function divideCharacter() {
	  var textbox = document.querySelectorAll('.divide-character');
	  var textboxArray = Array.prototype.slice.call(textbox); //Array
	
	  textboxArray.forEach(function (textbox) {
	    var text = textbox.textContent;
	    textbox.innerHTML = null;
	    text.split('').forEach(function (c) {
	      textbox.innerHTML += '<span class="letter"><span class="letter-inner">' + c + '</span></span>';
	    });
	  });
	}; // mouseStalker
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.divideCharacter = divideCharacter;
	
	var mouseStalker = function mouseStalker() {
	  //マウスストーカー用のdivを取得
	  var stalker = document.getElementById('sw-Stalker'); //aタグにホバー中かどうかの判別フラグ
	
	  var hovFlag = false; //マウスに追従させる処理 （リンクに吸い付いてる時は除外する）
	
	  document.addEventListener('mousemove', function (e) {
	    // if (!hovFlag) {
	    stalker.style.transform = 'translate(' + e.clientX + 'px, ' + e.clientY + 'px)'; // }
	  }); //リンクへ吸い付く処理
	
	  var linkElem = document.querySelectorAll('a:not(.no_stick_)');
	
	  for (var i = 0; i < linkElem.length; i++) {
	    //マウスホバー時
	    linkElem[i].addEventListener('mouseover', function (e) {
	      hovFlag = true; //マウスストーカーにクラスをつける
	
	      stalker.classList.add('hover'); //マウスストーカーの位置をリンクの中心に固定
	      // let rect = e.target.getBoundingClientRect();
	      // let posX = rect.left + (rect.width / 2);
	      // let posY = rect.top + (rect.height / 2);
	      // stalker.style.transform = 'translate(' + posX + 'px, ' + posY + 'px)';
	    }); //マウスホバー解除時
	
	    linkElem[i].addEventListener('mouseout', function (e) {
	      hovFlag = false;
	      stalker.classList.remove('hover');
	    });
	  }
	};
	
	exports.mouseStalker = mouseStalker;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// detail/app.bundle.js